import React from 'react';

import AppTheme from './theme';

export default {
    childContextTypes: {
        muiTheme: React.PropTypes.object,
    },

    getChildContext() {
        return {
            muiTheme: AppTheme,
        };
    },
};



// WEBPACK FOOTER //
// ./src/mui-theme.mixin.js